type Ticket = {
  publishingMode?: string;
};

/**
 * Messages which are private can be seen by
 * the estate and the person who sent the ticket.
 *
 * Private tickets have:
 * - accessibleByPersonIds (mostly an array with only one user id)
 * - publishingMode = "UNPUBLISHED"
 */
export const ticketIsPrivate = (ticket: Ticket | null | undefined): boolean => {
  const isPrivate = Boolean(
    ticket && ticket.publishingMode && ticket.publishingMode === "UNPUBLISHED",
  );
  return isPrivate;
};
